import { getDeclination } from "@litres/utils";
export default {
  ["Дата начала продаж {date}"]: (date?: string) =>
    `Дата начала продаж ${date}`,
  ["Закрыть"]: "Закрыть",
  ["Рекламный слайдер"]: "Рекламный слайдер",
  ["Используйте клавиши стрелок для переключения слайдов."]:
    "Используйте клавиши стрелок для переключения слайдов.",
  ["Ещё"]: "Ещё",
  ["Ещё {number}"]: (number?: number) => `Ещё ${number}`,
  ["Убрать"]: "Убрать",
  ["Меню"]: "Меню",
  ["От {min} до {max} символов"]: (data?: { min: number; max: number }) =>
    `От ${data?.min} до ${data?.max} ${getDeclination(data?.max || 0, ["символа", "символов", "символов"])}`,
  ["Минимум {count} символ"]: (count?: number) =>
    `Минимум ${count} ${getDeclination(count || 0, ["символ", "символа", "символов"])}`,
  ["Выбрать из списка"]: "Выбрать из списка",
  ["развернуто"]: "развернуто",
  ["свернуто"]: "свернуто",
  ["Модальное окно"]: "Модальное окно",
  ["Выбран"]: "Выбран",
  ["Не выбран"]: "Не выбран",
  ["Свернуть"]: "Свернуть",
  ["Эксклюзив"]: "Эксклюзив",
  ["Хит продаж"]: "Хит продаж",
  ["Новинка"]: "Новинка",
  ["Все книги, получившие эту награду"]: "Все книги, получившие эту награду",
  ["Предыдущий слайд"]: "Предыдущий слайд",
  ["Следующий слайд"]: "Следующий слайд",
  ["Оценить книгу на {count} балл из 5"]: (count?: number) =>
    `Оценить книгу на ${count} ${getDeclination(count || 0, ["балл", "балла", "баллов"])} из 5`,
  ["Снять оценку"]: "Снять оценку",
  ["{star} звезда из 5"]: (star?: number) =>
    `${star} ${getDeclination(star || 0, ["звезду", "звезды", "звезд"])} из 5`,
  ["предыдущий таб"]: "предыдущий таб",
  ["следующий таб"]: "следующий таб",
};
